module.exports = __webpack_public_path__ + "static/media/external_env_2_media_10.5de611bd.webp";